import Icon from 'src/assets/icon.svg';
import LogoDark from 'src/assets/logo-dark.svg';
import { Sidenav, Nav, HStack, VStack, Input, InputGroup, Box, Sidebar, Toggle } from 'rsuite';
import React, { useEffect, useState } from "react";
import { itemProduct } from "./ProductNavItems";
import Logo from "@components/Logo";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setIsLogged, setToken, setData } from "@auth/Actions";
import { useDispatch } from "react-redux";
import { setSectionName } from '@services/redux/slices/globalSlice';

function ProductSideNavBar({ profile, theme, service, id, name, country }) {
  const [expand] = useState(false);
  const [expanded, setExpanded] = React.useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Forcer expanded à false sur mobile
      if (mobile) {
        setExpanded(false);
      } else {
        setExpanded(true);
      }
    };

    // Vérifier au chargement initial
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Get active button from current route
  const getActiveButton = () => {
    const path = location.pathname;
    if (path === "/" || path === "/dashboard") return "dashboard";
    return path.substring(1); // Remove leading slash

  };

  const handleClick = (item) => {
    if (item.value === "quit") {
      dispatch(setIsLogged(false));
      dispatch(setToken(""));
      dispatch(setData([]));
      window.location = "/login";
    } else {
      navigate(`/${buildUrl(item.value)}`);
      dispatch(setSectionName(item?.sectionName || item.value))
    }
  };

  const buildUrl = (value) => {
    if (value === "dashboard") {
      return value;
    }
    return ["products", id, country, service, name, value].join("/");
  };

  const boutonActif = getActiveButton();
  const items = itemProduct[service]
    ? itemProduct[service]
    : itemProduct["standard"];
  const separator = items.length - 2;
  const isActive = (value) => {
    return location.pathname.includes(`/${value}`);
  };
  const Header = ({ expanded, onClick }) => {
    if (!expanded) {
      return (
        <HStack justifyContent="center">
          <img
            src={Icon}
            alt="Brand icon"
            className='cursor-pointer'
            style={{ width: 24, height: 24, cursor: "pointer" }}
            onClick={onClick}
          />
        </HStack>
      );
    }

    return (
    <VStack p="10px 10px 0 10px" spacing={12}>
        <HStack>
          <img
            src={LogoDark}
            alt="Brand logo"
            style={{ height: 24 }}
            onClick={onClick}
            className='px-3 cursor-pointer'
          />
        </HStack>
      </VStack>
    );
  };



  return (
    <>

      <Sidenav 
           expanded={expanded} 
           width={expanded ? 260 : 56}
           className="h-100 bg-white"
           style={{
             height: "100%",
             display: "flex",
             flexDirection: "column",
              width: expanded ? 240 : 56
           }}
           defaultOpenKeys={items.filter(item => item.type === "accordion").map(item => item.id)}
         >

     <Sidenav.Header className='mt-4'>
           <Header expanded={expanded} onClick={() => navigate("/dashboard")} />
         </Sidenav.Header>
         <Sidenav.Body className='pt-4' style={{ flex: 1, overflow: "hidden" }}>
           <Nav style={{ height: "100%", overflowY: "auto" }}>
            {items.map((item) => (
              <>
                {item.type === "button" ? (
                  <Nav.Item
                    key={item.id}
                    className={`fs-6 fw-light border-0 bg-white ${isActive(item.value) ? "text-blue" : ""
                      }`}
                    eventKey={item.id}
                    icon={item.icon}
                    onClick={() => handleClick(item)}
                  >
                    {t(item.title)}
                  </Nav.Item>
                ) : (
                  <Nav.Menu
                    eventKey={item.id}
                    trigger="hover"
                    title={t(item.title)}
                    icon={item.icon}
                    placement="rightStart"
                    className="fs-6 fw-light text-dark border-0"
                  >
                    {item.buttons.map((button) => (
                      <Nav.Item
                        key={button.id}
                        className={`${isActive(button.value) ? "text-blue" : ""}`}
                        eventKey={`${item.id}`}
                        // eventKey={`${item.id} - ${button.id}`}
                        onClick={() => handleClick(button)}
                      >
                        {t(button.title)}
                      </Nav.Item>
                    ))}
                  </Nav.Menu>
                )}
              </>))}

          </Nav>
        </Sidenav.Body>
        <div style={{ marginTop: 'auto' }} className='p-1 text-blue d-none d-md-block'>
               <Sidenav.Toggle onToggle={setExpanded} />
             </div>
      </Sidenav>
    </>
    
  );
}

export default ProductSideNavBar;
